import SearchBar3rdPage from "../SearchBar/SearchBar3rdPage";

const InitialDeliveryPage = () => {
  return (
    <>
      <div className="headerPage3">
        <SearchBar3rdPage />
      </div>
    </>
  );
};
export default InitialDeliveryPage;
